import React from 'react';
import { Grid } from '@material-ui/core';
import Dropdown from '../../../../materialUi/dropdown';
import PaymentForm from '../../../../materialUi/paymentForm';
import ApproveDiscountDialog from './approveDiscount';
import Button from '../../../../materialUi/btn';
import '../../../../css/payment.css';

function PaymentMethod({
  submitPayment,
  data,
  handleData,
  initialFee,
  userData,
  paymentStatus
}) {
  const [paymentMethod, setPaymentMethod] = React.useState('');
  const [paymentMethodMessage, setPaymentMethodMessage] = React.useState(false);
  const [discount, setDiscount] = React.useState('-');
  const [openDialog, setOpenDialog] = React.useState(false);
  const { userType } = userData.userData;

  const discountList = [
    { name: '-' },
    { name: '10%' },
    { name: '20%' },
    { name: '30%' },
    { name: '40%' },
    { name: '50%' },
    { name: 'Free' },
  ];

  const publicPaymentOptions = [
    { name: 'Credit card' }
  ]

  const adminPaymentOptions = [
    { name: 'Credit card' },
    { name: 'Debit card' },
    { name: 'Apple pay' },
    { name: 'Cash' }
  ]

  const [paymentMethods, setLocalPaymentMethod] = React.useState(
    userType.toLowerCase() === 'member' ? publicPaymentOptions : adminPaymentOptions
  );
  const calculateDiscount = (percentage) => ((percentage / 100) * -initialFee + initialFee).toFixed(2);

  const getDiscount = (selectedDiscount) => {
    setLocalPaymentMethod([{ name: 'Credit card' }, { name: 'Cash' }]);
    if (selectedDiscount === '-') {
      return initialFee;
    }
    if (selectedDiscount === '10%') {
      return calculateDiscount(10);
    }
    if (selectedDiscount === '20%') {
      return calculateDiscount(20);
    }
    if (selectedDiscount === '30%') {
      return calculateDiscount(30);
    }
    if (selectedDiscount === '40%') {
      return calculateDiscount(40);
    }
    if (selectedDiscount === '50%') {
      return calculateDiscount(50);
    }
    setLocalPaymentMethod([{ name: 'Cash' }]);
    setPaymentMethod('Cash');
    return 'Free';
  };

  const handleDiscount = (event) => {
    const { value } = event.target;
    const newFee = getDiscount(value);
    if (value === '50%' || value === 'Free') {
      setOpenDialog(true);
    } else {
      data.membership.fee = newFee;
      handleData(data);
    }
    setDiscount(value);
  };

  const handleValidation = (validation) => {
    if (validation) {
      const newFee = getDiscount(discount);
      data.membership.fee = newFee;
      handleData(data);
      setOpenDialog(false);
    }
  };

  const handleSendCardInformation = (nonce, paymentMethod, full_name) => {
    submitPayment({
      type: 'card',
      nonce,
      cardHolderName: full_name,
    });
  };

  const handleChangePaymentType = (event) => {
    setPaymentMethodMessage(false);
    setPaymentMethod(event.target.value);
  }

  const handleSendCashPayment = () => {
    if (!paymentMethod) return setPaymentMethodMessage('Payment method is required!');
    return submitPayment({
      type: paymentMethod.toLowerCase(),
      nonce: false,
      cardHolderName: false,
    });
  };

  React.useEffect(() => {
  }, [userData]);

  return (
    <Grid item xs={12} md className="paymentMethod-col">
      <Grid container spacing={2}>
        <Grid item xs={12} md>
          <Dropdown
            name="Payment"
            value={paymentMethod}
            handleChanges={handleChangePaymentType}
            error={paymentMethodMessage ? true : false}
            helperText={paymentMethodMessage}
            label="Payment method"
            listName={paymentMethods}
          />
        </Grid>
        {userData.userData.userType.toLowerCase() !== 'member' && (
          <Grid item xs={12} md={6}>
            <Dropdown
              name="Discount"
              value={discount}
              handleChanges={handleDiscount}
              error={false}
              helperText=""
              label="Discount(%)"
              listName={discountList}
            />
          </Grid>
        )}
        <Grid item xs={12}>
          {paymentMethod === 'Credit card' ? (
            <PaymentForm
              handleSaveOnDB={handleSendCardInformation}
              paymentStatus={paymentStatus}
            />
          ) : (
            <Grid
              container
              direction="row"
              justifyContent="flex-end"
              alignItems="center"
            >
              <Button
                label="SUBMIT PAYMENT"
                bgColor="#e76f50"
                color="white"
                bgColorHover="#ff8c68"
                colorHover="white"
                width={165}
                onClick={handleSendCashPayment}
              />
            </Grid>
          )}
        </Grid>
        <ApproveDiscountDialog
          open={openDialog}
          close={() => setOpenDialog(false)}
          handleValidation={handleValidation}
        />
      </Grid>
    </Grid>
  );
}

export default PaymentMethod;
